// extracted by mini-css-extract-plugin
export var container = "_40-0";
export var disabled = "_40-4";
export var fullWidth = "_40-3";
export var lined = "_40-1";
export var selected = "_40-5";
export var tab = "_40-2";